(() => {
  const selector = '.reveal';
  const observedElements = new WeakSet();
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const revealImmediately = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => {
      element.classList.add('is-visible');
    });
  };

  const ensureObserver = () => {
    if (observer || reducedMotionQuery.matches || !('IntersectionObserver' in window)) {
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
      }
    );
  };

  const observeReveals = (root = document) => {
    if (reducedMotionQuery.matches || !('IntersectionObserver' in window)) {
      revealImmediately(root);
      return;
    }

    ensureObserver();

    root.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains('is-visible') || observedElements.has(element)) return;
      observedElements.add(element);
      observer.observe(element);
    });
  };

  const initialize = () => {
    observeReveals(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    observeReveals(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    observeReveals(document);
  });

  const onMotionChange = () => {
    if (reducedMotionQuery.matches) {
      if (observer) {
        observer.disconnect();
        observer = undefined;
      }
      revealImmediately(document);
      return;
    }

    observeReveals(document);
  };

  if (typeof reducedMotionQuery.addEventListener === 'function') {
    reducedMotionQuery.addEventListener('change', onMotionChange);
  } else if (typeof reducedMotionQuery.addListener === 'function') {
    reducedMotionQuery.addListener(onMotionChange);
  }
})();
